import { Modal } from '@jouzen/ecom-components/v3/Modal';

import Video from '@/app/components/Video/Video';

import { useSizingPageModalContext } from '../contexts/SizingPageModalProvider';

const Gen4VideoModal = () => {
  const { or4VideoVisible, setOr4VideoVisible } = useSizingPageModalContext();
  const toggleModal = () => {
    setOr4VideoVisible(false);
  };

  return (
    <Modal
      isOpen={or4VideoVisible}
      onOpenChange={toggleModal}
      padding="large"
      size="large"
    >
      <div className="px-6 xl:px-24">
        <div className="aspect-video" data-cy="gen4-sizing-video-wrapper">
          <Video
            className="size-full"
            contentTitle="or4_sizing_video"
            location="sizing-hero"
            localizedSrc="sizing_gen4_sizing_video_src"
            playVideo={or4VideoVisible}
            preload="metadata"
            type="video/mp4"
            posterSrc="sizing/video-poster.png"
          />
        </div>
      </div>
    </Modal>
  );
};

export default Gen4VideoModal;
